import { render, staticRenderFns } from "./EVMTxSummary.vue?vue&type=template&id=f269abee&scoped=true&"
import script from "./EVMTxSummary.vue?vue&type=script&lang=ts&"
export * from "./EVMTxSummary.vue?vue&type=script&lang=ts&"
import style0 from "./EVMTxSummary.vue?vue&type=style&index=0&id=f269abee&scoped=true&lang=scss&"
import style1 from "./EVMTxSummary.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f269abee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTab,VTabItem,VTabs,VTooltip})
